import axios from "axios";
import { imgSrcToBlob } from "blob-util";
import moment from "moment";

export const requiredDefaultMessage = "Pertanyaan wajib diisi";

export const urlToFile = (fileUrl: string, fileName: string) => {
  return new Promise(async (resolve, reject) => {
    await imgSrcToBlob(fileUrl, "image/png", "Anonymous")
      .then((blob) => {
        resolve(blob);
      })
      .catch((err) => {
        reject(JSON.stringify(err));
      });
  });
};

export const validateEmail = (value: string) => {
  const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (pattern.test(value)) return;

  return "Pastikan email kamu valid";
};

export const handleIsRequired = (value: string) => {
  if (value?.trim()?.length > 0) return;

  return requiredDefaultMessage;
};

export const checkFilledData = (data: any) => {
  let countFilledData = 0;

  Object.keys(data)?.forEach((item) => {
    if (typeof data?.[item] === "string") {
      if (data?.[item]?.trim()?.length > 0) countFilledData++;
    } else {
      if (!!data?.[item]) countFilledData++;
    }
  });

  return countFilledData;
};

export const getStringSafely = (value: string | undefined) => {
  return value ?? "";
};

export const getBirthDate = (value: string) => {
  return moment(value).format("YYYY-MM-DD");
};

export const validatePhoneNumber = (value: string) => {
  if (value?.trim()?.length >= 10 && value?.trim()?.length <= 14) return;

  return "Nomor handphone harus memiliki 10 - 14 karakter";
};
